var _rect, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperatorProfileEditImagePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 211,
    viewBox: "0 0 211 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 211,
    rx: 38.8684,
    className: "fill bg",
    fill: "#EBEBEB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.49,
    cy: 71.4899,
    rx: 34.4898,
    ry: 34.4898,
    className: "fill stroke",
    fill: "white",
    stroke: "white",
    strokeWidth: 8.32895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0001 153.943C50.9908 151.518 51.5331 149.123 52.5859 146.939C55.8895 140.332 65.2057 136.83 72.9362 135.244C78.5114 134.054 84.1636 133.26 89.8508 132.866C100.38 131.941 110.97 131.941 121.499 132.866C127.186 133.264 132.838 134.059 138.414 135.244C146.145 136.83 155.461 140.001 158.764 146.939C160.882 151.391 160.882 156.56 158.764 161.012C155.461 167.95 146.145 171.122 138.414 172.641C132.845 173.88 127.191 174.697 121.499 175.086C112.929 175.812 104.319 175.945 95.7312 175.482C93.749 175.482 91.8329 175.482 89.8508 175.086C84.1804 174.702 78.5478 173.885 73.0023 172.641C65.2057 171.122 55.9556 167.95 52.5859 161.012C51.5385 158.803 50.9968 156.388 51.0001 153.943Z",
    className: "fill stroke",
    fill: "white",
    stroke: "white",
    strokeWidth: 8.32895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatorProfileEditImagePlaceholder);
export default __webpack_public_path__ + "static/media/operator-profile-edit-image-placeholder.39ead3b27c7f11501227739de8785929.svg";
export { ForwardRef as ReactComponent };